import React, { useEffect, useState } from "react";
import { IconImg } from "../../contents/Icons";
import { Util } from "../../util/Util";
import { StyledHeader } from "./style";
import { API } from "../../apis/dashboard.api";

import useDateRangeStore from "../../store/useDateRangeStore";
import useModalStore from "../../store/useModalStore";

export const Header = () => {
  const { setIsPeriodFilterModal } = useModalStore();
  const { mainStartDate, mainEndDate, fetchDataTrigger } = useDateRangeStore();

  const [potholeData, setPotholeData] = useState({
    total: "-",
    detected: "-",
    repaired: "-",
    received: "-",
    linked: "-",
  });

  useEffect(() => {
    const fetchData = async () => {
      const form = {
        startDate: Util.formatDate(mainStartDate),
        endDate: Util.formatDate(mainEndDate),
      };
      try {
        const data = await API.getMainData(form);
        setPotholeData({
          total: data?.totalPthCnt?.toLocaleString() ?? "0",
          detected: data?.detectedPthCnt?.toLocaleString() ?? "0",
          repaired: data?.repairedPthCnt?.toLocaleString() ?? "0",
          received: data?.receivedDataCnt?.toLocaleString() ?? "0",
          linked: "100",
        });
      } catch (error) {
        console.error("Fetching error:", error);
        setPotholeData({
          total: "오류",
          detected: "오류",
          repaired: "오류",
          received: "오류",
          linked: "오류",
        });
      }
    };
    fetchData();
  }, [fetchDataTrigger, mainStartDate, mainEndDate]);

  return (
    <StyledHeader>
      <div className="header-container">
        <div className="content">
          <div className="title-box">
            <p className="header">PMS 포트홀</p>
            <p className="center">국토관리사무소별</p>
            <p className="selected-date-range">
              ({Util.formatDate(mainStartDate)} ~ {Util.formatDate(mainEndDate)}
              )
            </p>
            <button
              onClick={() => setIsPeriodFilterModal(true)}
              className="selected-condition"
            >
              조회조건변경
            </button>
          </div>

          <div className="dashboard">
            <div className="title">
              <IconImg.Network />
              <p>조회기간에 따른 전국 포트홀 현황</p>
            </div>
            <div className="card-wrap">
              <div className="card total">
                <p className="label">총 포트홀 현황</p>
                <p className="value">
                  <span>{potholeData.total}</span>건
                </p>
              </div>
              <div className="card detected">
                <p className="label">검출된 포트홀 현황</p>
                <p className="value">
                  <span>{potholeData.detected}</span>건
                </p>
              </div>
              <div className="card received">
                <p className="label">보수된 포트홀 현황</p>
                <p className="value">
                  <span>{potholeData.repaired}</span>건
                </p>
              </div>
              <div className="card operation">
                <p className="label">수신된 데이터 현황</p>
                <p className="value">
                  <span>{potholeData.received}</span>건
                </p>
              </div>
              <div className="card linkage">
                <p className="label">당일 지킴이 연계율</p>
                <p className="value">{potholeData.linked}%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledHeader>
  );
};
